<template>
    <section v-if="show">
        <h2 class="title pink">
            File claim
        </h2>
        <hr>
        <form>
            <div class="row">
                <div class="col-12">
                    <b-form-group label="Policy Number" label-for="policyNumber" label-class="font-italic font-small">
                        <b-form-input v-model="policyNumber" class="font-italic font-small form-control-lg" disabled></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12">
                    <b-form-group label="Name" label-for="full_name" label-class="font-italic font-small">
                        <b-form-input v-model="fullName" id="full_name" class="font-italic font-small form-control-lg" disabled></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12">
                    <b-form-group label="Date of birth" label-for="date_of_birth" label-class="font-italic font-small">
                        <b-form-input v-model="date_of_birth" class="font-italic font-small form-control-lg" disabled></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <b-form-group label="Email" label-for="email" label-class="font-small">
                        <input v-model="email" type="text" class="form-control" :class="{ 'is-invalid': $v.email.$error }"  id="email" placeholder="Email">
                        <div class="invalid-feedback" v-if="!$v.email.required">Field is required</div>
                        <div class="invalid-feedback" v-if="!$v.email.email">Invalid email format</div>
                        <div class="invalid-feedback" v-if="!$v.email.maxLength">Field too long. Max length 100 characters</div>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <b-form-group label="Phone Number (+1 234567890)" label-for="phone_number" label-class="font-small">
                        <input v-model="phone_number" type="text" class="form-control" :class="{ 'is-invalid': $v.phone_number.$error }">
                        <div class="invalid-feedback" v-if="!$v.phone_number.required">Field is required</div>
                        <div class="invalid-feedback" v-if="!$v.phone_number.maxLength">Field too long. Max length 50 characters</div>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h4 class="mb-2 mt-4">Claim Details</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="event_place">Place of Event</label>
                        <input v-model="event_place" type="text" class="form-control" :class="{ 'is-invalid': $v.event_place.$error }">
                        <div class="invalid-feedback" v-if="!$v.event_place.required">Field is required</div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="event_date">Date of Event (Year-Month-Day)</label>
                        <input v-model="event_date" type="text" class="form-control" :class="{ 'is-invalid': $v.event_date.$error }" v-mask="'####-##-##'">
                        <div class="invalid-feedback" v-if="!$v.event_date.required">Field is required</div>
                        <div class="invalid-feedback" v-if="$v.event_date.required && !$v.event_date.validDate">Invalid date</div>
                        <div class="invalid-feedback" v-if="$v.event_date.required && $v.event_date.validDate && !$v.event_date.dateInCoverage">Date of event must be prior to your policy expiry date ({{ expire_date }})</div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="select">Coverage</label>
                        <select class="form-control" :class="{ 'is-invalid': $v.event_description.$error }" v-model="coverage" @change="selectCoverage">
                            <option value="">Select a Coverage</option>
                            <option v-for="(coverage_obj, coverage) in coveragesDict" :value="coverage" :key="coverage">{{ coverage }}</option>
                        </select>
                        <div class="invalid-feedback" v-if="!$v.coverage.required">Field is required</div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="select">Type of claim</label>
                        <select class="form-control" :class="{ 'is-invalid': $v.claim.$error }" :disabled="coverage == ''" v-model="claim">
                            <option value="">Select a type of claim</option>
                            <option v-for="(claim_obj, claim) in claimsList" :value="claim_obj" :key="claim">{{ claim_obj }}</option>
                        </select>
                        <div class="invalid-feedback" v-if="!$v.claim.required">Field is required</div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="event_description">Short Description</label>
                        <textarea v-model="event_description" type="text" class="form-control" :class="{ 'is-invalid': $v.event_description.$error }" rows="3"
                            max-rows="6">
                        </textarea>
                        <div class="invalid-feedback" v-if="!$v.event_description.required">Field is required</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h4 class="mb-2 mt-4">Bank details for reimbursement</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="event_place">Iban/Bank Account Number</label>
                        <input v-model="bank_identifier" type="text" class="form-control" :class="{ 'is-invalid': $v.bank_identifier.$error }">
                        <div class="invalid-feedback" v-if="!$v.bank_identifier.required">Field is required</div>
                        <div class="invalid-feedback" v-if="!$v.bank_identifier.maxLength">Field too long. Max length 50 characters</div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <b-form-group label="Swift/BIC">
                        <b-form-input v-model="bank_swift_bic"></b-form-input>
                        <div class="invalid-feedback" v-if="!$v.bank_swift_bic.maxLength">Field too long. Max length 50 characters</div>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <b-form-group label="Bank account holder different from Insured?">
                        <b-form-radio-group id="different-holder" v-model="bank_different_holder" name="radio-sub-component">
                            <b-form-radio value="Yes">Yes</b-form-radio>
                            <b-form-radio value="No">No</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <div v-if="bank_different_holder == 'Yes'">
                        <b-form-group label="Bank Account Holder">
                            <b-form-input v-model="bank_account_holder"></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="row-btn">
                        <button type="button" class="btn btn-primary" @click="openClaim">Next</button>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
//import api from '../../http/api.js'

import { mapFields } from 'vuex-map-fields';
import { required, requiredIf, email, maxLength } from 'vuelidate/lib/validators'
import store from '../store'
import moment from 'moment'

const validDate = (value) => {
    //console.log(value);
    const result = moment(value).isValid()
    //console.log(result)
    return result
}

const dateInCoverage = (value) => {
    return store.getters['openClaim/getExpireDate'] >= value;
}

export default {
    beforeRouteEnter: function (to, from, next) {
        if(!store.getters.privacyClaimAccepted){
            next({ name: 'PrivacyClaim' });
        } else {
            store.dispatch('openClaim/initialize').then(() => { 
                next();
            });
        }
    }, 
    data: function () {
        return {
            coveragesDict: {
                "Medical Expenses" : [
                    "Medical, pharmaceutical and hospital costs already authorized by the Insurance Company",
                    "Medical, pharmaceutical and hospital costs NOT authorized by the Insurance Company",
                    "Dental expenses",
                    "Medical expenses incurred in the city of residence, following hospitalization abroad",
                    "Expenses following illness or injury that has caused cosmetic disfigurement",
                    "Expenses for psychological assessments following an Illness or Accident during Travel that has resulted in the Insured being admitted to hospital for more than 30 days",
                ],
                "Travel Accidents" : [
                    "travel injury",
                    "death of Insured",
                    "temporary inability to work",
                    "coma resulting from an injury",
                    "permanent disability"
                ],
                "Flight Accidents" : [
                    "flight injury"                    
                ],
                "Third Party Liability" : [
                    "death/personal injury",
                    "damage to third party objects/animals",
                    "damage caused by pets",
                    "damage caused by the ownership and use of cycles, non-motorised vehicles and boats no longer than 6.5 meters, golf carts",
                    "damage caused by playing sports, including races, not at the professional level, leisure activities and camping",
                    "damage caused to a rental vehicle (in excess of what was paid by the insurance coverage on the vehicle itself)",
                ],
                "Trip Cancellation" : [
                    "Illness, Injury or death of the Insured or one of their Family members",
                    "selection of the insured as juror or sworn testimony to appear before the judicial authorities",
                    "damage to the Insured's dwelling as a result of fire, burglary or natural disasters, severe enough to make his presence necessary",
                    "Act of Terrorism"
                ],
                "Travel Interruption" : [
                    "medical repatriation of the Insured, organised and carried out by the Operations Centre",
                    "early return due to death or hospitalisation with a prognosis of more than 7 consecutive days of a Family member, authorised and organised by the Operations Centre",
                    "act of terrorism or a natural disaster at the Trip destination",
                ],
                "Travel Inconveniences" : [
                    "Delayed departure and cancelled flight",
                    "Lost connection",
                    "Missed boarding",
                    "Delayed baggage delivery",
                    "Hijack",
                    "Early return to residence due to loss of samples"
                ],
                "Cover Stay" : [
                    "Medical detention for safety reasons"
                ],
            },
            claimsList: [],
        }
    },
    validations: {
        email: {
            required,
            email,
            maxLength: maxLength(100)
        },
        phone_number: {
            required,
            maxLength: maxLength(50)
        },
        bank_identifier: {
            required,
            maxLength: maxLength(50)
        },
        bank_swift_bic: {
            required,
            maxLength: maxLength(50)
        },
        event_place: {
            required,
        },
        event_date: {
            required,
            validDate,
            dateInCoverage
        },
        event_description: {
            required
        },
        coverage: {
            required
        },
        claim: {
            required: requiredIf(function() {
                //console.log("requiredIf", model);
                return this.coverage != "";
            })
        }
    },
    computed: {
        policyNumber(){
            return this.$store.state.userInfo.policyNumber;
        },
        ...mapFields('openClaim', [
            'show',
            'insured_details.first_name',
            'insured_details.second_name',
            'insured_details.date_of_birth',
            'insured_details.city',
            'insured_details.country',
            'insured_details.phone_prefix',
            'insured_details.phone_number',
            'insured_details.email',
            'details.bank_identifier',
            'details.bank_swift_bic',
            'details.bank_different_holder',
            'details.bank_account_holder',
            'event_place',
            'event_date',
            'event_description',
            'coverage',
            'claim',
            'expire_date'
        ]),
        fullName: function(){
            return this.$store.state.userInfo.name;    
        }
    },
    created() {
        //if(!this.prefetchedData){
        //    this.$store.dispatch('openClaim/fetchData');
        //}   
        
        if(this.coverage != ""){
            this.claimsList = this.coveragesDict[this.coverage]
        }
    },
    methods: {
        selectCoverage: function(){
            // reset claim field filled by previous coverage choice
            if(this.claim != ""){
                this.claim = "";
            }
            
            if(this.coverage != ""){
                this.claimsList = this.coveragesDict[this.coverage]
            } else {
                this.claimsList = [];
            }
        },
        openClaim(){
            this.$v.$touch()
            if (this.$v.$invalid) {
                return false;
            }

            this.$store.dispatch('openClaim/openClaim')
                .then((result)=>{
                    //console.log(result);
                    this.$store.dispatch('openClaim/resetState')
                    this.$router.push({ name: 'FileClaimEnd', params: { claimId: result.data.data.id } });
                });
        },
    },
}
</script>